/* eslint-disable react-hooks/exhaustive-deps */
import { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import {
	getAuthConnectLoader,
	getAuthRefreshToken,
	getSavedUrl,
} from 'redux/reducers/auth/selectors';
import {
	getOrganizationsRequest,
	getUserInfoRequest,
	setOrganization,
	getHubspotVisitorTokenRequest,
} from 'redux/reducers/user/reducer';
import { Box, Button, Card, CardContent, CardMedia, Typography } from '@mui/material';
import {
	getUserInfo,
	getUserInfoLoader,
	getUserOrganizations,
	getUserOrganizationsLoader,
} from 'redux/reducers/user/selectors';
import { EASSpinner } from 'components/EASSpinner';
import { getMerchantIdSuccess } from 'redux/reducers/auth/reducer';
import { nanoid } from '@reduxjs/toolkit';
import { AnimatedBackground } from 'ui/AnimatedBackground';
import { PATHS } from 'routes/constants';

export const SignIn: FC = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const codeIsLoading = useSelector(getAuthConnectLoader);
	const userInfo = useSelector(getUserInfo);
	const userInfoLoading = useSelector(getUserInfoLoader);
	const organizations = useSelector(getUserOrganizations);
	const organizationsLoading = useSelector(getUserOrganizationsLoader);
	const refreshToken = useSelector(getAuthRefreshToken);

	const savedUrl = useSelector(getSavedUrl);
	console.log('savedUrl page', savedUrl);

	useEffect(() => {
		dispatch(getUserInfoRequest());
	}, [dispatch, codeIsLoading, refreshToken]);

	const handleButtonClick = (em: number) => {
		if (!em || !organizations?.rows[em - 1]?.group_id) return;
		dispatch(getMerchantIdSuccess({ xMerchantId: organizations?.rows[em - 1]?.group_id }));
		dispatch(setOrganization(organizations?.rows[em - 1]));
		dispatch(getHubspotVisitorTokenRequest());

		navigate(
			`${String(!savedUrl || savedUrl === PATHS.SIGN_IN_PAGE || savedUrl === PATHS.INACTIVITY_PAGE ? PATHS.SHOPS_PAGE : savedUrl)}`,
		);
	};

	if (codeIsLoading || userInfoLoading || organizationsLoading) return <EASSpinner />;
	return (
		<AnimatedBackground>
			<Card
				sx={{
					width: { xs: '100%', sm: 400 },
					height: { xs: '100vh', sm: 'auto' },
					textAlign: 'center',
					mt: { sm: '10vh', xs: 0 },
					color: '#016193',
					position: 'relative',
					zIndex: 1000,
					'&.MuiCard-root': {
						borderRadius: { sm: '12px!important', xs: '0!important' },
					},
				}}
			>
				<CardMedia sx={{ height: 160 }} image="/img/fon.png" />
				<div
					style={{
						position: 'absolute',
						top: 0,
						left: 0,
						maxWidth: 400,
						padding: '40px 100px',
					}}
				>
					<img
						src="/img/EAS-project-logo.svg"
						alt=""
						style={{
							width: '100%',
						}}
					/>
				</div>
				<CardContent>
					<Typography gutterBottom variant="h5" component="h1">
						Welcome
					</Typography>
					<Typography gutterBottom variant="h4" component="h2">
						{userInfo?.fullName}
					</Typography>
					<hr style={{ border: '.2px solid  #016193', marginTop: '20px' }} />
					{(organizations?.rows?.length ?? 0) > 1 && (
						<Typography gutterBottom variant="subtitle2" component="div">
							Select the merchant interface to continue
						</Typography>
					)}
					<Box
						sx={{
							display: 'flex',
							flexDirection: 'column',
							alignContent: 'start',
							justifyContent: 'start',
							textAlign: 'left',
							padding: '0 16px',
							marginTop: '10px',
							// gap: 1,
						}}
					>
						{(organizations?.rows?.length ?? 0) > 1 &&
							organizations?.rows?.map((item, index) => (
								<Button
									sx={{
										textAlign: 'left',
										alignContent: 'start',
										justifyContent: 'start',
										textTransform: 'none',
										width: '100%',
										fontWeight: 'bold',
										borderRadius: '12px',
										// border: '1px solid #016193',
										// padding: '5px 5px',
									}}
									key={nanoid()}
									onClick={() => handleButtonClick(index + 1)}
								>
									{item.group_name}
								</Button>
							))}
						{organizations?.rows.length === 1 && (
							<Button
								variant="contained"
								sx={{
									alignContent: 'center',
									justifyContent: 'center',
									textTransform: 'none',
									width: '100%',
									fontWeight: 'bold',
									borderRadius: '12px',
									fontSize: '1.4rem',
								}}
								onClick={() => handleButtonClick(1)}
							>
								Start
							</Button>
						)}
					</Box>
				</CardContent>
			</Card>
		</AnimatedBackground>
	);
};
